import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

declare module '@mui/material/Divider' {
  interface DividerPropsVariantOverrides {
    small: true;
  }
}

const MuiDivider: Components<Omit<Theme, 'components'>>['MuiDivider'] = {
  styleOverrides: {
    root: {
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      boxSizing: 'border-box',
    },
  },
  variants: [
    {
      props: { variant: 'small' },
      style: {
        margin: '8px 0',
      },
    },
  ],
};

export default MuiDivider;
